
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AppBottomSheet',
  data() {
    return { isVisible: false };
  },
  computed: {
    ...mapState('bottomSheet', ['bottomSheet', 'hasHistoryEntry']),
    useBackgroundBlur() {
      return this.bottomSheet?.useBackgroundBlur !== false;
    }
  },
  watch: {
    bottomSheet() {
      if (this.bottomSheet) {
        this.isVisible = false;
        requestAnimationFrame(() => (this.isVisible = true));
        this.pushHistoryEntry();
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopstate);
  },
  methods: {
    ...mapActions('bottomSheet', ['closeBottomSheet', 'setHasHistoryEntry']),
    pushHistoryEntry() {
      window.addEventListener('popstate', this.onPopstate);

      if (this.hasHistoryEntry) return;

      window.history.pushState(
        { ...window.history.state, cremaBottomSheet: true },
        ''
      );
      this.setHasHistoryEntry(true);
    },
    onPopstate() {
      this.setHasHistoryEntry(false);
      this.close();
    },
    close() {
      window.removeEventListener('popstate', this.onPopstate);

      if (this.hasHistoryEntry) {
        this.setHasHistoryEntry(false);
        window.history.back();
      }

      this.isVisible = false;
    }
  }
};
